import { browserHistory } from 'react-router';

if (__DEV__) {
	window.jsFlags = {
		isHeliosEnabled: true,
		etaPollEnabled: true,
		enableODSecondFold: true,
		themeType: '',
		returnIssueId: '4',
		returnSubIssueId: '6',
		moThemeBanner: {
			ID:
				'https://rukminim1.flixcart.com/www/{@width}/{@height}/promos/01/09/2021/cf562ae2-11ea-4b59-a7d9-e3045467dc48.png?q={@quality}',
			BBD:
				'https://rukminim1.flixcart.com/www/{@width}/{@height}/promos/01/09/2021/27831500-978e-416d-9484-cc956184efc6.png?q={@quality}'
		},
		scratchCardCelebrationIcon: 'https://sa-web-h1a.flixcart.com/mosaic/ss/scratch-card-0307d708.svg',
		scratchCardSummaryIcon: 'https://sa-web-h1a.flixcart.com/mosaic/ss/scratch-card-gift-e47f8199.svg',
		iOSInvoiceDownloadEnabled: true,
		blobioAttachmentsDownloadEnabled: false,
		disableOdV4: false,
		enableOcV4: 'true',
		hcPagePhoneNoEdit: true,
		disableImageGuardrail: false,
		enableModifyAction: true,
		fdpV2Complete: true, // if true, TrackableComponent uses cc fdp helper
		FDPNativeV2Reenabled: false, // if true, cc fdp helper uses rv fdp lib
		forceV3ChatForShopsy: false,
		enableScxChat: false,
		showWhiteHeader: true,
		newAddressWidgetFixEnabled: true,
		enableDesktopODv4: true,
		enablePharma: false,
		enableEhcChatWithUs: true,
		enableDesktopOCv4: true,
		enableConsignmentNote: false,
		enableWebHeaderOnApps: true,
		enableMOv4: true,
		disableMapDegradationFix: false,
		horizontalScrollFixEnabled: false
	};
}


// window.jsFlags = Object.assign({}, window.jsFlags, {
// 	mapiEndpoint: "https://msite-stage10.flipkart.com/mapiproxy/10.83.70.234" 
// })


const GLOBAL_FLAGS = window.jsFlags || {};
const location = browserHistory.getCurrentLocation ? browserHistory.getCurrentLocation() : {};
const query = location.query || {};
/**
 * Can be used based on User Agent
 * e.g. disable timelineV4 for iOS
 * 			let overrides = { timelineV4Enabled: isIOS ? false: true, ...query }
 *
 * Putting queries in the end make them super flags - can override everything.
 */
const overrides = {
	...query
};

export default { ...GLOBAL_FLAGS, ...overrides };
